import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  menu: any = [
    {
      titulo: 'Principal',
      icono: 'mdi mdi-clipboard-check',
      submenu: [
        { titulo: 'ACTUALIZACIÓN DE DATOS', url: '/afiliados'}
      ]
    }
  ];

  constructor() { }
}
